<div class="pagination-wrapper">
  <div class="pagination-buttons">
    <button
      mat-icon-button
      (click)="changePage(pagination().currentPage - 1)"
      [disabled]="pagination().currentPage === 1"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>

    @for (page of pageArray(); track $index) {
      @if (page) {
        <button
          mat-button
          (click)="changePage(page)"
          [ngClass]="{ active: page === pagination().currentPage }"
        >
          {{ page }}
        </button>
      } @else {
        <span>…</span>
      }
    }

    <button
      mat-icon-button
      (click)="changePage(pagination().currentPage + 1)"
      [disabled]="pagination().currentPage === totalPages()"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <div class="page-size-select">
    <span class="page-size-label">
      {{ 'tablePagination.pageSizeLabel' | translate }}
    </span>
    <mat-form-field appearance="outline" class="page-size-field">
      <mat-select
        class="custom-arrow"
        #pageSizeSelect
        [(value)]="pagination().pageSize"
        (selectionChange)="changePageSize(pageSizeSelect.value)"
      >
        @for (size of pagination().pageSizeOptions; track $index) {
          <mat-option [value]="size">
            {{ size }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
